import React from 'react';
import { Box, Typography, Stack, Button, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

type Props = {
  text: string;
  onRunTest: () => void;
  loading?: boolean;
  progress?: string;
};

export const RunTest = ({ text, loading, onRunTest, progress }: Props) => {
  return (
    <Box
      data-testid="hardware-run-test"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '217px',
      }}
    >
      <Stack width="194px" sx={{ alignItems: 'center', textAlign: 'center' }}>
        <InfoIcon
          sx={{
            fontSize: '1.8rem',
            color: 'info',
            mb: 2,
          }}
        />
        <Typography variant="body2" fontWeight={400} color="info">
          {text}
        </Typography>
        {loading && (
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', top: '15px', left: '13px' }}>{progress}%</span>
            <CircularProgress size={50} />
          </div>
        )}
        {!loading && (
          <Button
            variant="contained"
            color="primary"
            onClick={onRunTest}
            sx={{ borderRadius: 1, width: '100%', mt: 3 }}
          >
            Run Test
          </Button>
        )}
      </Stack>
    </Box>
  );
};
